/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TapeLibraryLoadEndpointRequest
 */
export interface TapeLibraryLoadEndpointRequest {
    /**
     * 
     * @type {string}
     * @memberof TapeLibraryLoadEndpointRequest
     */
    barcode: string;
}

export function TapeLibraryLoadEndpointRequestFromJSON(json: any): TapeLibraryLoadEndpointRequest {
    return TapeLibraryLoadEndpointRequestFromJSONTyped(json, false);
}

export function TapeLibraryLoadEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TapeLibraryLoadEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'barcode': json['barcode'],
    };
}

export function TapeLibraryLoadEndpointRequestToJSON(value?: TapeLibraryLoadEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'barcode': value.barcode,
    };
}


